export default __webpack_public_path__ + "static/media/Jean2.af87f68f.mp3";